// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"dabb65f36fdab2aaae6f","883":"677ef6e379f69b3a16e2"}[chunkId] + ".js";
};